@if (startPoint()){
    <map-marker [position]="startPoint()" [options]="startPointIconOptions" />
}

@for(item of routeSegments(); track item.id; let last = $last; ) {
    @if (last && !endPoint()){
        <map-marker (mapClick)="getMarkerInfo(item)" [position]="item.currentLocation" [options]="endPointIconOptions" />
    }
    @else if (isSuccessIcon(item)){
        <map-marker (mapClick)="getMarkerInfo(item)" [position]="item.currentLocation"  #markerRef />
    }
    @else if (isFinishedIcon(item)){
        <map-marker (mapClick)="getMarkerInfo(item)" [position]="item.currentLocation"  #markerRef />
    }
    @else if (!last){
        <map-marker (mapClick)="getMarkerInfo(item)" [position]="item.currentLocation"  #markerRef />
    }
}

@if (endPoint()){
    <map-marker [position]="endPoint()" [options]="endPointIconOptions" />
}